
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"fetchingData":"Laden ...","canceled":"Abgebrochen","restart":"Wiederholen"},"en":{"fetchingData":"Loading ...","canceled":"Canceled","restart":"Repeat"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();